import { useEffect, useRef, useState } from 'react';
import { useDataProvider } from 'react-admin';

export const useCollectionPointDevices = collectionPointId => {
    const dataProvider = useDataProvider();
    const cacheRef = useRef(new Map());
    const [devices, setDevices] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (collectionPointId == null || collectionPointId === '') {
            setDevices(null);
            setError(null);
            setIsLoading(false);
            return;
        }

        const cacheKey = String(collectionPointId);
        if (cacheRef.current.has(cacheKey)) {
            setDevices(cacheRef.current.get(cacheKey));
            setError(null);
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setDevices(null);
        setError(null);
        setIsLoading(true);

        dataProvider
            .getOne('collection-point', { id: collectionPointId })
            .then(({ data }) => {
                if (cancelled) return;
                const nextDevices = Array.isArray(data?.devices) ? data.devices : [];
                cacheRef.current.set(cacheKey, nextDevices);
                setDevices(nextDevices);
            })
            .catch(loadError => {
                if (cancelled) return;
                setError(loadError);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [collectionPointId, dataProvider]);

    return { devices, isLoading, error };
};
